<template>
  <div>
    <ExpenseRequestMain
      :level="userLevel"
      :is-gold="true"
      :show-level-info="true"
      :page-config="{
        action: 'manage',
        subject: 'GOLDPLANAPPLYV2'
      }"
      @status-changed="handleStatusChange"
      @form-saved="handleFormSaved"
      @update:level="userLevel=$event"
    />
  </div>
</template>

<script setup lang="ts">
import ExpenseRequestMain from './ExpenseRequestMain.vue';

definePage({
  meta: {
    action: 'manage',
    subject: 'GOLDPLANAPPLY',
  },
})

// 登入者資料
const userData = useStorage('userData', {}).value;

// 從API或配置獲取用戶等級
const userLevel = ref(null); // 黃金計劃通常是A級

// 事件處理
const handleStatusChange = (status: string) => {
  console.log('狀態變更:', status);
  // 可以在這裡處理狀態變更的邏輯
};

const handleFormSaved = (data: any) => {
  console.log('表單已儲存:', data);
  // 可以在這裡處理表單儲存後的邏輯
};

// 初始化時設定用戶等級
// onMounted(async () => {

// });
</script> 